<template>
  <div class="owner-room-container">
    <div class="bg-white index-1-right-item owner-card" @click="_toOwnerInfo">
      <div class="card-header">
        <div class="header-accent owner"></div>
        <div class="header-content">
          <div class="header-icon owner">
            <i class="el-icon-user"></i>
          </div>
          <div class="header-title">
            <span>{{ $t('propertyIndex.residentRegStats') }}</span>
            <div class="header-subtitle">{{ $t('propertyIndex.ownerDesc') || '住户登记管理概览' }}</div>
          </div>
        </div>
        <div class="owner-summary">
          <div class="summary-item">
            <span class="summary-value">{{ indexOwnerRoomInfo.bindCount + indexOwnerRoomInfo.unbindCount }}</span>
            <span class="summary-label">{{ $t('propertyIndex.totalOwner') || '总住户' }}</span>
          </div>
        </div>
      </div>
      <div id="ownerRoomCount" style="height:250px"></div>
      <div class="flex justify-between text-center stats-container">
        <div v-for="(item, index) in stats" :key="index">
          <div class="index-bottom-number">{{ item.value }}</div>
          <div class="index-bottom-number-desc">{{ $t(`propertyIndex.${item.label}`) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { getOwnerRegisterIndex } from '@/api/index/propertyIndexApi'

export default {
  name: 'IndexOwnerRoom',
  data() {
    return {
      indexOwnerRoomInfo: {
        unbindCount: 0,
        bindCount: 0,
        unbindRoomCount: 0,
        bindRoomCount: 0,
      },
      ownerRoomChart: null
    }
  },
  computed: {
    stats() {
      return [
        { label: 'unregistered', value: this.indexOwnerRoomInfo.unbindCount },
        { label: 'registered', value: this.indexOwnerRoomInfo.bindCount },
        { label: 'unboundRoom', value: this.indexOwnerRoomInfo.unbindRoomCount },
        { label: 'boundRoom', value: this.indexOwnerRoomInfo.bindRoomCount }
      ]
    }
  },
  created() {
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    if (this.ownerRoomChart) {
      this.ownerRoomChart.dispose()
    }
  },
  methods: {
    handleResize() {
      if (this.ownerRoomChart) {
        this.ownerRoomChart.resize()
      }
    },
    async _loadIndexOwnerRegisterData() {
      const param = {
        page: 1,
        row: 10,
        communityId: this.getCommunityId()
      }

      try {
        const res = await getOwnerRegisterIndex(param)
        Object.assign(this.indexOwnerRoomInfo, res.data)
        
        this.$nextTick(() => {
          const dom = document.getElementById('ownerRoomCount')
          if (!dom) return
          
          if (this.ownerRoomChart) {
            this.ownerRoomChart.dispose()
          }
          this.ownerRoomChart = echarts.init(dom)
          this._initOwnerEcharts(
            this.ownerRoomChart,
            this.indexOwnerRoomInfo.bindCount,
            this.indexOwnerRoomInfo.unbindCount,
            this.$t('propertyIndex.residentInfo'),
            this.$t('propertyIndex.registered'),
            this.$t('propertyIndex.unregistered'),
            '#4B7AF0',
            '#E2EDF6'
          )
        })
      } catch (error) {
        console.error('请求失败处理', error)
      }
    },
    _initOwnerEcharts(chart, userCount, freeCount, _title, _userCountName, _freeCountName, userColor, freeColor) {
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          right: 10,
          top: 'center',
          textStyle: {
            color: '#606266'
          },
          data: [_userCountName, _freeCountName]
        },
        color: [userColor, freeColor],
        series: [{
          name: _title,
          type: 'pie',
          radius: ['40%', '65%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'center'
          },
          emphasis: {
            label: {
              show: true,
              fontSize: '16',
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: false
          },
          data: [
            { value: userCount, name: _userCountName },
            { value: freeCount, name: _freeCountName }
          ]
        }]
      }
      
      chart.setOption(option)
    },
    _toOwnerInfo() {
      this.$router.push('/pages/property/listOwner')
    }
  }
}
</script>

<style lang="scss" scoped>
.owner-room-container {
  .owner-card {
    .card-header {
      .header-accent.owner {
        background: linear-gradient(180deg, #9C27B0, #BA68C8);
      }
      
      .header-icon.owner {
        background: linear-gradient(135deg, #9C27B0 0%, #BA68C8 100%);
        box-shadow: 0 4px 8px rgba(156, 39, 176, 0.3);
      }
    }
  }
  
  .index-1-right-item {
    background: #fff;
    border-radius: 4px;
    padding: 15px;
    height: 100%;
    overflow: hidden;
    transition: box-shadow 0.3s;
    
    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }
    
    .card-header {
      position: relative;
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      padding: 0 10px;
      
      .header-accent {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 4px;
        background: linear-gradient(180deg, #409EFF, #1890ff);
        border-radius: 2px;
      }
      
      .header-content {
        display: flex;
        align-items: center;
        margin-left: 10px;
        
        .header-icon {
          width: 48px;
          height: 48px;
          background: linear-gradient(135deg, #409EFF 0%, #1890ff 100%);
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 12px;
          box-shadow: 0 4px 8px rgba(64, 158, 255, 0.3);
          
          i {
            font-size: 24px;
            color: #fff;
          }
        }
        
        .header-title {
          span {
            font-size: 18px;
            font-weight: bold;
            color: #303133;
            display: block;
          }
          
          .header-subtitle {
            font-size: 12px;
            color: #909399;
            margin-top: 4px;
          }
        }
      }
      
      .owner-summary {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        text-align: center;
        
        .summary-item {
          background: linear-gradient(135deg, #f3e5f5, #e1bee7);
          padding: 8px 16px;
          border-radius: 8px;
          
          .summary-value {
            display: block;
            font-size: 24px;
            font-weight: bold;
            color: #7b1fa2;
          }
          
          .summary-label {
            font-size: 12px;
            color: #7b1fa2;
          }
        }
      }
    }
    
    .index-title {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 15px;
      color: #333;
    }
    
    .stats-container {
      padding-top: 15px;
      border-top: 1px solid #eee;
      
      > div {
        flex: 1;
      }
      
      .index-bottom-number {
        font-size: 20px;
        font-weight: bold;
        color: #333;
      }
      
      .index-bottom-number-desc {
        font-size: 12px;
        color: #999;
        margin-top: 5px;
      }
    }
  }
}
</style>